import React from "react";
import {
  Checkbox,
  Tooltip,
  WithTooltip,
  ThreeStateValue,
  Icon,
} from "@abb/abb-common-ux-react";
import { IDeviceProperties } from "../../models/device/DeviceProperties";
import { Translation } from "react-i18next";
import * as CONSTANTS from "../../utilities/Constants";
import {
  ABB_PROGRAM_POINTER,
  ABB_CARET_RIGHT,
} from "../../utilities/IconConstants";

interface IProperties {
  fetchedProperties: IDeviceProperties[];
  inderminateValue: ThreeStateValue;
  onAllPropertyChecked: (value: any) => void;
  onPropertyChecked: (value: any, index: number) => void;
  onArrowClick: () => void;
  mappingProperties: any;
}

export class BrowseProperty extends React.Component<IProperties> {
  private _noResultsFound = "No Results Found";
  private _name = "";

  public render() {
    const uniqueFilteredProperties = this.props.fetchedProperties?.filter((obj: any, index: any) => {
      return obj.uniqueId ? index === this.props.fetchedProperties?.findIndex((i:any) => obj?.uniqueId === i?.uniqueId) : obj
    })
    return (
      <Translation>
        {(t) => (
          <div className="box-below-form h-100 mb-4" style={{ clear: "both" }}>
            <div className="col-md-12 p-0">
              <div className="box-circle">
                <p className="box-circle-text"> 3 </p>
              </div>
              <div className="ml-4">
                <p className="sidebar-main-title font-weight-bold ml-2">
                  {t(CONSTANTS.LABEL_PROPERTIES)}
                </p>
              </div>
              <hr className="hr-line" />
            </div>
            <div className="col-12">
              <div className="row">
                <div className="col-xl-3">
                  <div className="overflow-auto float-left no-padding mt-1">
                    <div className="mt-2 p-4">
                      <p className="sidebar-main-title d-inline font-weight-bold ml-2 mr-3">
                        {t(CONSTANTS.FROM_CONNECTED_INSTRUMENT)}
                      </p>
                      <WithTooltip>
                        <Icon
                          name={ABB_PROGRAM_POINTER}
                          sizeClass="medium"
                          color="black"
                          className={
                            this.props.mappingProperties.length
                              ? "icon-program-pointer-active"
                              : "icon-program-pointer"
                          }
                          onClick={this.props.onArrowClick}
                        />
                        <Tooltip>
                          <p>{t("Copy Selected to Right")}</p>
                        </Tooltip>
                      </WithTooltip>
                      <table className="table tbl">
                        <thead>
                          <tr>
                            <th
                              className="table-title text-uppercase"
                              style={{ background: "#f5f5f5", border: "none" }}
                            >
                              <Checkbox
                                sizeClass="small"
                                disabled={
                                  uniqueFilteredProperties.length === 0
                                }
                                value={this.props.inderminateValue}
                                style={{ height: 18, marginTop: "-26px" }}
                                onChange={this.props.onAllPropertyChecked}
                                allowIndeterminate={true}
                              />
                            </th>
                            <td
                              className="table-title text-uppercase"
                              style={{ background: "#f5f5f5", border: "none" }}
                            >
                              {t(CONSTANTS.LABLE_ID)}
                            </td>
                            <td
                              className="table-title text-uppercase"
                              style={{ background: "#f5f5f5", border: "none" }}
                            >
                              {t(CONSTANTS.LABLE_NAME)}{" "}
                            </td>
                          </tr>
                        </thead>
                        <tbody>
                          {uniqueFilteredProperties.length === 0 ? (
                            <tr>
                              <td colSpan={3} className="no-result text-center">
                                {t(this._noResultsFound)}
                              </td>
                            </tr>
                          ) : (
                            uniqueFilteredProperties.map(
                              (property, index) => (
                                <tr key={index}>
                                  <td className="select-row">
                                    <Checkbox
                                      label=""
                                      sizeClass="small"
                                      value={property.isSelected}
                                      // tslint:disable-next-line: jsx-no-lambda
                                      onChange={(val) =>
                                        this.props.onPropertyChecked(
                                          property,
                                          index
                                        )
                                      }
                                      allowIndeterminate={true}
                                    />
                                  </td>
                                  <td>{property.id}</td>
                                  <td>
                                    <WithTooltip>
                                      <div className="component-container">
                                        <span className="d-inline-block width-5rem text-ellipsis">
                                          {t(property.shortProperty)}
                                        </span>
                                      </div>
                                      <Tooltip>{t(property.name)}</Tooltip>
                                    </WithTooltip>
                                  </td>
                                </tr>
                              )
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="col-xl-9">
                  <div className="overflow-auto float-left width-class no-padding mt-1">
                    <div className="mt-2 p-4">
                      <p className="title font-weight-bold mb-1">
                        {t(CONSTANTS.FROM_INSTRUMENT_TYPE)}
                      </p>
                      <div className="table-responsive-sm">
                        <table className="table tbl-edit">
                          <thead>
                            <tr>
                              <td
                                className="table-title id text-uppercase"
                                style={{ width: "9%", background: "#f5f5f5" }}
                              >
                                {t(CONSTANTS.LABLE_ID)}{" "}
                                <span className="required_header">*</span>{" "}
                              </td>
                              <td
                                className="table-title name text-uppercase"
                                style={{ width: "20%", background: "#f5f5f5" }}
                              >
                                {t(CONSTANTS.LABLE_NAME)}{" "}
                                <span className="required_header">*</span>{" "}
                              </td>
                              <td
                                className="table-title property-name text-uppercase"
                                style={{ width: "25%", background: "#f5f5f5" }}
                              >
                                {t(
                                  CONSTANTS.MENU_PROPERTY +
                                    " " +
                                    CONSTANTS.LABLE_NAME
                                )}{" "}
                                <span className="required_header">*</span>{" "}
                              </td>
                              <td
                                className="table-title direction text-uppercase"
                                style={{ width: "14%", background: "#f5f5f5" }}
                              >
                                {t(CONSTANTS.LABLE_INSTRUMENT_DIRECTIONS)}{" "}
                                <span className="required_header">*</span>{" "}
                              </td>
                              <td
                                className="table-title unit text-uppercase"
                                style={{ width: "8%", background: "#f5f5f5" }}
                              >
                                {t(CONSTANTS.LABEL_UNIT)}
                              </td>
                              <td
                                className="table-title unit text-uppercase"
                                style={{ width: "8%", background: "#f5f5f5" }}
                              >
                                {t(CONSTANTS.LABEL_DECIMALS)}
                              </td>
                              <td
                                className="table-title min text-uppercase"
                                style={{ width: "8%", background: "#f5f5f5" }}
                              >
                                {t(CONSTANTS.LABLE_MIN)}
                              </td>
                              <td
                                className="table-title max text-uppercase"
                                style={{ width: "8%", background: "#f5f5f5" }}
                              >
                                {t(CONSTANTS.LABLE_MAX)}
                              </td>
                            </tr>
                          </thead>
                          <tbody>{this.props.children}</tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="clearfix" />
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}
